const Footer = () => {
    return (
        <footer className="bg-[#001D42] text-white py-4 text-center">
            <p className="font-titillium font-bold tablet:text-lg mb-1">Copyright © 2025 | All Rights Reserved</p>
            <p className="font-league font-medium text-sm tablet:text-lg">Developed by&nbsp;
                <a href="https://www.facebook.com/itzzmerov" target="_blank" rel="noreferrer">
                    <span className="text-custom-light-blue">itzzmerov</span>
                </a>
            </p>
        </footer>
    );
};

export default Footer;